module.exports = __webpack_public_path__ + "img/rwxx-active.7dc8903a.svg";